// extracted by mini-css-extract-plugin
export default {"paymentSection":"v1-z"};